<template>
  <div>
    <!-- <ul class="float-btn" :class="{'float-right-btn': position === 'right'}" v-drag  v-if="list != null && list != undefined && list.length != 0 && miniProgramBackFlag!=1">
      <li v-for="(item,index) in list" :key="index" :class="{'float-btn-item': styleType === '', 'float-btn-item-style1': styleType === 'style1'}" @click="jump(item)">
        <i :class="`float-btn-icon iconfont ${item.icon?item.icon:'icon-common_icon_returnback'}`"></i>
        <p class="float-btn-text">{{ item.text }}</p>
      </li>
    </ul> -->

    <!--ai数智人进入的子页面，都显示悬浮入口--->
    <div @click="backToAIManHome">
      <movable-panel :position="{x: 'right', y: 'calc((100% - 150px) / 2)'}" v-if="aiManFlag === '1'" text="">
        <img class="ai-man-icon" :src="aiManFlagImgUrl"/>
      </movable-panel>
    </div>
 </div>
</template>

<script>
import MovablePanel from "@/components/movable-panel/movable-panel.vue";

export default {
  name: "float-btn",
  components: {
    MovablePanel,
  },
  props: {
    buttonsList: {
      type: Array,
      default(){
        return []
      }
    },
    position: {
      type: String,
      default(){
        return 'left'
      }
    },
    styleType: {
      type: String,
      default(){
        return ''
      }
    }
  },
  data() {
    return {
      isXCX: this.Session.get('entranceFlag') == 4, //在小程序里
      list: [],
      aiManFlag: '0', //ai数字人进入的
      aiManFlagImgUrl:'https://img.zoenet.cn/h5-img/zoe-health-app/ai_popup_fjsfy.png',
    }
  },
  mounted() { 
    // if (localStorage.getItem('htmlBackInfo')) {
    //   //创建返回首页按钮
    //   this.setBackInfoHtml()
    // }

    // 初始化this.$route，延迟执行
   setTimeout(()=>{
    this.aiManFlag = this.$route.query.aiManFlag || sessionStorage.getItem('aiManFlag') || '0'
    sessionStorage.setItem('aiManFlag', this.aiManFlag)

    //有配置取机构的配置logo
    if (sessionStorage.getItem('aiManFlagImgUrl')) {
      this.aiManFlagImgUrl = sessionStorage.getItem('aiManFlagImgUrl')
    }
    },2000)
  },
  watch:{
    buttonsList:{
      handler(val){
        this.list = JSON.parse(JSON.stringify(val));
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    jump(item) {
      if (typeof item.url === 'number') {
        history.go(item.url);
        return;
      }
      if (!item.url) return;
      if (item.type === 'func') {
        return this.$emit('on-click', item);
      }
      location.assign(item.url);
    },

    //创建返回首页按钮
    setBackInfoHtml(){
      if (document && document.body && !document.getElementById("htmlBackInfo")) {
        var htmlBackInfo = document.createElement('div');
        htmlBackInfo.setAttribute("id", "htmlBackInfo");
        let firstChild = document.body.firstChild
        document.body.insertBefore(htmlBackInfo, firstChild)
        htmlBackInfo.innerHTML = JSON.parse(localStorage.getItem('htmlBackInfo'))
      }
    },
    //返回数字人首页
    backToAIManHome() {
      if(this.isXCX){
       location.href = process.env.VUE_APP_health_xcx +'form/ai-helper/digital-human'
      }else{
      location.href = process.env.VUE_APP_health +'form/ai-helper/digital-human'
      }
    }
  },
  directives: {
    drag: {
      inserted(el, bindings) {
        let boundary = 10;
        el.ontouchstart = function (e) {
          let windowWidth = window.innerWidth;
          let windowHeight = window.innerHeight;
          let elementRect = el.getBoundingClientRect();
          let elementHeight = elementRect.height;
          let elementWidth = elementRect.width
          let disX = e.touches[0].pageX - el.offsetLeft;
          let disY = e.touches[0].pageY - el.offsetTop;
          el.ontouchmove = function (ev) {
            ev.preventDefault();
            let pageX = ev.touches[0].pageX;
            let pageY = ev.touches[0].pageY;
            let left = pageX - disX
            let top = pageY - disY;
            if (top > boundary && top <= windowHeight - boundary - elementHeight) {
              el.style.top = top + 'px';
            }
            if (left <= 15) {
              el.style.left = '0';
              el.style.right = 'unset';
            } else if (left >= windowWidth - elementWidth - 15){
              el.style.right = '0';
              el.style.left = 'unset';
            } else {
              [...el.children].every(childNode => {
                childNode.style.borderRadius = `${elementHeight / el.children.length }px`;
              })
              el.style.left = left + 'px'
              el.style.right = 'unset';
            }
            el.ontouchend = function () {
              [...el.children].map(childNode => {
                childNode.style.borderRadius = ``;
              })
              el.style.left = el.style.right = '';
              el.ontouchmove = el.ontouchend = null;
            };
          };
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
@import "float-btn.less";
</style>
